// extracted by css-extract-rspack-plugin
export default {"ErrorContainer":"GenericError_ErrorContainer__3epG6","ErrorWrapper":"GenericError_ErrorWrapper__OL3rs"};